import { render, staticRenderFns } from "./ErpIcmDbDataUseInfo.vue?vue&type=template&id=d215ca90&scoped=true&"
import script from "./ErpIcmDbDataUseInfo.vue?vue&type=script&lang=js&"
export * from "./ErpIcmDbDataUseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d215ca90",
  null
  
)

export default component.exports